<script>
import axios from '@/utils/axios';
import { pincodeWiseAddress } from '@/utils/admin';
import { getStandardUnits, getDimensionalUnits } from '@/utils/units';

export default {
  inject: ['setLoading'],
  data() {
    return {
      errors: {},
      viewMode: false,
      id: '',
      code: '',
      name: '',
      type: 'manufacturing',
      address: '',
      city: '',
      state: '',
      country: '',
      pincode: '',
      status: 'active',
      subtotal: 0,
      tax_amount: 0,
      total: 0,
      items_dropdown: [],
      brands_dropdown: [],
      party_type: '',
      party_id: null,
      quotation_id: null,
      quotations_dropdown: [],
      items: [
        { item_group_id: null, item_name: null, unique_items: [], brand_id: null, item: null, items_list: [], allocated_quantity: 1, unit_price: 0, tax_id: null, calculation_type: 'standard', dimensions: [{ width: 0, height: 0, qty: 1 }], base_unit: '', selectedUnit: null, availableUnits: [], size: 0, conversion_factor: 0, conversion_rate: 0, rmt_width_multiplier: 1, rmt_height_multiplier: 1, originalPrice: 0 }
      ],
      document: null,
      documentName: '',
      module_url: 'work-orders',
      documents: [],
      item_groups: [],
      standardUnits: [],
      dimensionalUnits: [],
    };
  },

  methods: {

async onQuotationSelect(quotationId) {
  if (!quotationId) {
    this.items = [{ item_group_id: null, item_name: null, unique_items: [], brand_id: null, item: null, items_list: [], allocated_quantity: 1, unit_price: 0, tax_id: null, calculation_type: 'standard', dimensions: [{ width: 0, height: 0, qty: 1 }], base_unit: '', selectedUnit: null, availableUnits: this.standardUnits, size: 0, conversion_factor: 0, conversion_rate: 0, rmt_width_multiplier: 1, rmt_height_multiplier: 1, originalPrice: 0 }];
    return;
  }

  this.setLoading(true);
  try {
    const response = await axios.get(`/quotations/${quotationId}/edit`); 
    const data = response.data.data;

    if (data.quotation_items && data.quotation_items.length) {
      this.items = data.quotation_items.map(row => ({
        item_group_id: row.item?.item_group_id || null,
        item_name: row.name || row.item?.name || null,
        unique_items: [],
        brand_id: row.item?.brand_id || null,
        item: row.item || { id: row.item_id, name: row.name },
        items_list: [],
        item_id: row.item_id,
        allocated_quantity: parseFloat(row.quantity || 1),
        unit_price: parseFloat(row.unit_price || 0),
        originalPrice: parseFloat(row.unit_price || 0),
        tax_id: row.tax_id || null,
        calculation_type: row.item?.calculation_type || 'standard',
        base_unit: row.item?.unit || '',
        unit: row.unit || '',
        selectedUnit: null,
        availableUnits: row.item?.calculation_type === 'dimensional' ? this.dimensionalUnits : this.standardUnits,
        rmt_width_multiplier: row.item?.rmt_width_multiplier || 1,
        rmt_height_multiplier: row.item?.rmt_height_multiplier || 1,
        size: 0,
        conversion_factor: 0,
        conversion_rate: 0,
        dimensions: (row.dimensions && row.dimensions.length)
          ? row.dimensions.map(d => ({ width: parseFloat(d.width || 0), height: parseFloat(d.height || 0), qty: parseFloat(d.quantity || 1) }))
          : [{ width: 0, height: 0, qty: 1 }],
      }));

      for (let i = 0; i < this.items.length; i++) {
        const row = this.items[i];
        if (row.item_group_id) {
          try {
            const res = await axios.get('/items/unique-dropdown', { params: { item_group_id: row.item_group_id } });
            row.unique_items = res.data.data || [];
          } catch (e) { console.log('Unique items load error:', e.message); }
        }
        if (row.item_name) {
          try {
            const res = await axios.get('/items/item-wise-brand', { params: { item_name: row.item_name } });
            row.items_list = res.data.data || [];
            if (row.item && row.items_list.length) {
              const matched = row.items_list.find(i => i.id === row.item.id);
              if (matched) row.item = matched;
            }
          } catch (e) { console.log('Brand items load error:', e.message); }
        }
        if (row.unit) {
          row.selectedUnit = row.availableUnits.find(u => u.value === row.unit) || null;
        }
        if (row.calculation_type === 'dimensional') {
          this.updateAmount(i);
        }
      }
    }
  } catch (error) {
    this.$swalToast('Failed to load quotation items', 'error');
  } finally {
    this.setLoading(false);
  }
},

  async onCategorySelect(index, itemGroupId) {
  const row = this.items[index];
  row.item_group_id = itemGroupId;
  row.item_name = null;
  row.unique_items = [];
  row.item = null;
  row.item_id = null;
  row.brand_id = null;
  row.items_list = [];
  row.unit_price = 0;
  row.tax_id = null;
  row.calculation_type = 'standard';
  row.dimensions = [{ width: 0, height: 0, qty: 1 }];
  row.selectedUnit = null;
  row.availableUnits = this.standardUnits;
  row.size = 0;

  if (!itemGroupId) return;

  try {
    const response = await axios.get('/items/unique-dropdown', {
      params: { item_group_id: itemGroupId }
    });
    row.unique_items = response.data.data || [];
  } catch (error) {
    this.$swalToast('Failed to load items for selected category', 'error');
  }
},

async onUniqueItemSelect(index, itemName) {
  const row = this.items[index];
  row.item_name = itemName;
  row.item = null;
  row.item_id = null;
  row.brand_id = null;
  row.items_list = [];
  row.unit_price = 0;
  row.tax_id = null;
  row.calculation_type = 'standard';
  row.dimensions = [{ width: 0, height: 0, qty: 1 }];
  row.selectedUnit = null;
  row.availableUnits = this.standardUnits;
  row.size = 0;

  if (!itemName) return;

  try {
    const response = await axios.get('/items/item-wise-brand', {
      params: { item_name: itemName }
    });
    row.items_list = response.data.data || [];
  } catch (error) {
    this.$swalToast('Failed to load brands for selected item', 'error');
  }
},

    createViaLead(party_type, party_id) {
      this.resetForm();
      this.fetchUnits();
      this.party_type = party_type;
      this.party_id = party_id;
      this.loadDropdowns();
      if (party_type === 'App\\Models\\Lead' && party_id) {
        this.loadQuotationsByLead(party_id);
      }
    },

async loadQuotationsByLead(leadId) {
      this.quotations_dropdown = [];
      try {
        const response = await axios.get(`/quotations/by-lead/${leadId}`);
        let list = response.data.data || [];
        if (!Array.isArray(list)) {
          list = list ? [list] : [];
        }
        // latest revision upar — descending sort
        this.quotations_dropdown = list.sort(
          (a, b) => (b.revision_number || 0) - (a.revision_number || 0)
        );
      } catch (error) {
        console.log('Quotation load error:', error.message);
        this.$swalToast('Failed to load quotations', 'error');
      }
    },

    async loadDropdowns() {
      try {
        const res = await axios.get('/item-groups');
        this.item_groups = res.data.data || [];
      } catch (error) {
        console.log('Dropdown load error:', error.message);
      }
    },

onBrandSelect(index, selectedItem) {
      const row = this.items[index];
      if (!selectedItem) {
        row.item = null;
        row.item_id = null;
        row.brand_id = null;
        row.unit_price = 0;
        row.tax_id = null;
        return;
      }
      row.item = selectedItem;
      row.item_id = selectedItem.id;
      row.brand_id = selectedItem.brand_id;
      row.unit_price = parseFloat(selectedItem.price || 0);
      row.originalPrice = parseFloat(selectedItem.price || 0);
      row.tax_id = selectedItem.tax_id || null;

      row.calculation_type = selectedItem.calculation_type || 'standard';
      row.dimensions = [{ width: 0, height: 0, qty: 1 }];

      if (row.calculation_type === 'dimensional') {
        row.availableUnits = this.dimensionalUnits;
        if (selectedItem.unit) {
          row.selectedUnit = this.dimensionalUnits.find(u => u.value === selectedItem.unit) || null;
          row.unit = selectedItem.unit;
          row.base_unit = selectedItem.unit;
          row.rmt_width_multiplier = selectedItem.rmt_width_multiplier || 1;
          row.rmt_height_multiplier = selectedItem.rmt_height_multiplier || 1;
        } else {
          row.selectedUnit = null;
          row.base_unit = '';
        }
        this.updateAmount(index);
      } else {
        row.availableUnits = this.standardUnits;
        row.allocated_quantity = 1;
      }
    },

        onItemUnitSelected(index, selectedUnit){
      const row = this.items[index];
      row.selectedUnit = selectedUnit;
      if(selectedUnit){
        row.unit = selectedUnit.value;
      }else{
        row.unit = '';
      }
      this.updateAmount(index);
    },

    // onItemSelect(index, itemId) {
    //   const row = this.items[index];
    //   if (!itemId) {
    //     row.item_id = null;
    //     row.unit_price = 0;
    //     row.tax_id = null;
    //     return;
    //   }
    //   const product = row.items_list.find(p => p.id === itemId);
    //   if (product) {
    //     row.unit_price = parseFloat(product.price || 0);
    //     row.tax_id = product.tax_id || null;
    //   }
    // },

    async fetchUnits(){
      try{
        const [standard, dimensional] = await Promise.all([
          getStandardUnits(),
          getDimensionalUnits()
        ]);
        this.standardUnits = standard;
        this.dimensionalUnits = dimensional;
      }catch(error){
        this.$swalToast(error.message, 'error');
      }
    },

    getUnitFactor(unitValue){
      const unit = this.dimensionalUnits.find(u => u.value === unitValue);
      return unit?.factor || 1;
    },

    addDimensionRow(itemIndex) {
      this.items[itemIndex].dimensions.push({ width: 0, height: 0, qty: 1 });
    },

    removeDimensionRow(itemIndex, dimIndex) {
      if (this.items[itemIndex].dimensions.length === 1) return;
      this.items[itemIndex].dimensions.splice(dimIndex, 1);
      this.updateAmount(itemIndex);
    },

    updateAmount(index){
      const row = this.items[index];
      const price = parseFloat(row.unit_price) || 0;

      if(row.calculation_type === 'dimensional'){
        const base_unit = row.base_unit || '';
        const selected_unit = row.unit || base_unit;
        let totalSize = 0;
        let totalAmount = 0;
        let totalQty = 0;

        (row.dimensions || []).forEach(dim => {
          const width = parseFloat(dim.width) || 0;
          const height = parseFloat(dim.height) || 0;
          const qty = Math.max(1, parseFloat(dim.qty) || 1);
          totalQty += qty;

          if(selected_unit === 'Rmt'){
            const rmt_w = parseFloat(row.rmt_width_multiplier) || 1;
            const rmt_h = parseFloat(row.rmt_height_multiplier) || 1;
            const size = (((width / 1000) * rmt_w) + ((height / 1000) * rmt_h)) * qty;
            dim._size = size;
            dim._amount = price * size;
            totalSize += size;
            totalAmount += dim._amount;
          } else {
            const base_factor = this.getUnitFactor(base_unit);
            const selected_factor = this.getUnitFactor(selected_unit);
            const size_in_sqmtr = (width / 1000) * (height / 1000) * qty;
            const size = size_in_sqmtr * selected_factor;
            const conversion_factor = selected_factor / base_factor;
            const conversion_rate = price / conversion_factor;
            dim._size = size;
            dim._amount = conversion_rate * size;
            totalSize += size;
            totalAmount += dim._amount;

            row.conversion_factor = conversion_factor;
            row.conversion_rate = conversion_rate;
          }
        });

        if(selected_unit === 'Rmt'){
          row.conversion_factor = 1;
          row.conversion_rate = price;
        }

        row.size = totalSize;
        row.allocated_quantity = totalQty;
      }
    },

    checkPincode() {
      if (this.pincode.length < 6) {
        this.errors.pincode = ["The pincode field must be 6 digits."];
      } else {
        delete this.errors.pincode;
        clearTimeout(this.pincodeTimeout);
        this.pincodeTimeout = setTimeout(() => {
          this.addressByPincode();
        }, 500);
      }
    },

    async addressByPincode() {
      this.setLoading(true);
      try {
        const response = await pincodeWiseAddress(this.pincode);
        const data = response.data.data;
        if (data?.city)    this.city    = data.city;
        if (data?.state)   this.state   = data.state;
        if (data?.country) this.country = data.country;
      } catch (error) {
        console.log('Pincode lookup failed:', error.message);
      } finally {
        this.setLoading(false);
      }
    },

    async viewWorkOrder(row) {
      await this.openWorkOrder(row);
      this.viewMode = true;
    },

    async openWorkOrder(row = null) {
      this.resetForm();
      await this.fetchUnits();
      await this.loadDropdowns();

      if (row !== null) {
        this.setLoading(true);
        try {
          const response = await axios.get(`/${this.module_url}/${row.id}`);
          const data = response.data.data;
          this.id         = data.id;
          this.code       = data.code;
          this.name       = data.name;
          this.type       = data.type || 'manufacturing';
          this.address    = data.address;
          this.city       = data.city;
          this.state      = data.state;
          this.country    = data.country;
          this.pincode    = data.pincode;
          this.status     = data.status;
          this.quotation_id = data.quotation_id || null;
          if (data.party_type === 'App\\Models\\Lead' && data.party_id) {
            await this.loadQuotationsByLead(data.party_id);
          }
          this.subtotal   = data.subtotal;
          this.tax_amount = data.tax_amount;
          this.total      = data.total;
          this.documents = data.documents || [];

if (data.work_order_items && data.work_order_items.length) {
  this.items = data.work_order_items.map(item => {
    const calcType = item.item?.calculation_type || 'standard';
    const availableUnits = calcType === 'dimensional' ? this.dimensionalUnits : this.standardUnits;
    const unitValue = item.unit || item.item?.unit || '';
    const selectedUnit = unitValue ? availableUnits.find(u => u.value === unitValue) : null;

    return {
      item_group_id: item.item?.item_group_id || null,
      item_name: item.item?.name || null,
      unique_items: [],
      brand_id: item.item?.brand_id || null,
      item: item.item || { id: item.item_id, name: item.item?.name },
      items_list: [],
      item_id: item.item_id,
      allocated_quantity: item.allocated_quantity,
      available_quantity: item.available_quantity,
      unit_price: parseFloat(item.unit_price),
      originalPrice: parseFloat(item.unit_price),
      tax_id: item.tax_id,
      calculation_type: calcType,
      base_unit: item.item?.unit || '',
      unit: unitValue,
      selectedUnit: selectedUnit,
      availableUnits: availableUnits,
      size: 0,
      conversion_factor: 0,
      conversion_rate: 0,
      rmt_width_multiplier: item.item?.rmt_width_multiplier || 1,
      rmt_height_multiplier: item.item?.rmt_height_multiplier || 1,
      dimensions: (item.dimensions && item.dimensions.length > 0)
        ? item.dimensions.map(d => ({
            width: parseFloat(d.width || 0),
            height: parseFloat(d.height || 0),
            qty: parseFloat(d.quantity || 1),
          }))
        : [{ width: 0, height: 0, qty: 1 }],
    };
  });

  for (let i = 0; i < this.items.length; i++) {
    const row = this.items[i];
    if (row.item_group_id) {
      try {
        const res = await axios.get('/items/unique-dropdown', {
          params: { item_group_id: row.item_group_id }
        });
        row.unique_items = res.data.data || [];
      } catch (e) {
        console.log('Unique items load error:', e.message);
      }
    }
    if (row.item_name) {
      try {
        const res = await axios.get('/items/item-wise-brand', {
          params: { item_name: row.item_name }
        });
        row.items_list = res.data.data || [];
        if (row.item && row.items_list.length) {
          const matched = row.items_list.find(i => i.id === row.item.id);
          if (matched) row.item = matched;
        }
      } catch (e) {
        console.log('Brand items load error:', e.message);
      }
    }
  }

  this.items.forEach((_, index) => {
    if (this.items[index].calculation_type === 'dimensional') {
      this.updateAmount(index);
    }
  });
}
        } catch (error) {
          this.$swalToast(error.message, 'error');
        } finally {
          this.setLoading(false);
        }
      }
    },

    addItem() {
      this.items.push({ item_group_id: null, item_name: null, unique_items: [], brand_id: null, item: null, items_list: [], allocated_quantity: 1, unit_price: 0, tax_id: null, calculation_type: 'standard', dimensions: [{ width: 0, height: 0, qty: 1 }], base_unit: '', selectedUnit: null, availableUnits: this.standardUnits, size: 0, conversion_factor: 0, conversion_rate: 0, rmt_width_multiplier: 1, rmt_height_multiplier: 1, originalPrice: 0 });
    },

    removeItem(index) {
      if (this.items.length > 1) this.items.splice(index, 1);
    },

    handleDocChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.document = file;
        this.documentName = file.name;
      }
    },

    removeDoc() {
      this.document = null;
      this.documentName = '';
      if (this.$refs.woDocInput) {
        this.$refs.woDocInput.value = '';
      }
    },

    async saveWorkOrder() {
      this.errors = {};

      if (!this.name) {
        this.$swalToast('Please enter work order name', 'error');
        return;
      }
      if (!this.address) {
        this.$swalToast('Please enter address', 'error');
        return;
      }
      if (!this.city) {
        this.$swalToast('Please enter city', 'error');
        return;
      }
      for (let i = 0; i < this.items.length; i++) {
        if (!this.items[i].item_id) {
          this.$swalToast(`Please select an item for row ${i + 1}`, 'error');
          return;
        }
      }

      this.setLoading(true);
      try {
        const payload = {
          name: this.name,
          type: this.type,
          address: this.address,
          city: this.city,
          state: this.state || '',
          country: this.country || '',
          pincode: this.pincode || '',
          quotation_id: this.quotation_id || '',
          party_type: this.party_type || '',
          party_id: this.party_id || '',
          items: this.items.map(item => {
            const payloadItem = {
              item_id: item.item_id,
              allocated_quantity: item.allocated_quantity,
              unit_price: item.unit_price,
              tax_id: item.tax_id || null,
            };
            if (item.calculation_type === 'dimensional') {
              payloadItem.dimensions = (item.dimensions || []).map(d => ({
                width: d.width,
                height: d.height,
                quantity: d.qty,
              }));
            }
            return payloadItem;
          }),
        };

        let response;

        if (this.id) {
          // Edit — JSON, backend update method mein document nahi hai
          response = await axios.put(`/${this.module_url}/${this.id}`, payload);
        } else {
          // Create — FormData with optional document
          const formData = new FormData();
          Object.keys(payload).forEach(key => {
            if (key === 'items') return;
            if (payload[key] !== null && payload[key] !== undefined) {
              formData.append(key, payload[key]);
            }
          });
          payload.items.forEach((item, index) => {
            Object.keys(item).forEach(key => {
              if (key === 'dimensions') {
                (item.dimensions || []).forEach((dim, dIndex) => {
                  formData.append(`items[${index}][dimensions][${dIndex}][width]`, dim.width ?? '');
                  formData.append(`items[${index}][dimensions][${dIndex}][height]`, dim.height ?? '');
                  formData.append(`items[${index}][dimensions][${dIndex}][quantity]`, dim.quantity ?? '');
                });
              } else {
                formData.append(`items[${index}][${key}]`, item[key] ?? '');
              }
            });
          });
          if (this.document) {
            formData.append('document', this.document);
          }
          response = await axios.post(`/${this.module_url}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });
        }

        this.$swalToast(response.data.message);
        this.$emit('updated');
        this.$closeModal('work_order_modal');
        this.resetForm();
      } catch (error) {
        if (error.type == 'validation' && typeof error.errors === 'object') {
          this.errors = error.errors;
        } else if (error.type == 'validation' && typeof error.errors === 'string') {
          this.$swalToast(error.errors, 'error');
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    formatCurrency(val) {
      return parseFloat(val || 0).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
    },

    resetForm() {
      this.viewMode = false;
      this.id = ''; this.code = ''; this.name = '';
      this.type = 'manufacturing';
      this.address = ''; this.city = ''; this.state = '';
      this.country = ''; this.pincode = ''; this.status = 'active';
      this.subtotal = 0; this.tax_amount = 0; this.total = 0;
      this.errors = {};
      this.document = null;
      this.documentName = '';
      this.items = [{ item_group_id: null, item_name: null, unique_items: [], brand_id: null, item: null, items_list: [], allocated_quantity: 1, available_quantity: 0, unit_price: 0, tax_id: null, calculation_type: 'standard', dimensions: [{ width: 0, height: 0, qty: 1 }], base_unit: '', selectedUnit: null, availableUnits: this.standardUnits, size: 0, conversion_factor: 0, conversion_rate: 0, rmt_width_multiplier: 1, rmt_height_multiplier: 1, originalPrice: 0 }];
      this.party_type = '';
      this.party_id = null;
      this.quotation_id = null;
      this.quotations_dropdown = [];
      this.documents = [];
    },

  },
};
</script>

<style scoped>
.wo-main {
  flex: 1; display: flex; flex-direction: column; overflow: hidden;
  background: #f1f5f9;
}
.wo-topbar {
  background: #fff; border-bottom: 1px solid #e2e8f0;
  padding: 12px 22px;
  display: flex; align-items: center; justify-content: space-between;
  flex-shrink: 0;
}
.wo-page-title { font-size: 14px; font-weight: 700; color: #0f172a; }
.wo-page-sub { font-size: 11px; color: #94a3b8; }
.wo-close-btn {
  width: 30px; height: 30px; border-radius: 7px;
  background: #f1f5f9; border: 1px solid #ef4444;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; font-size: 13px; transition: all .15s;
  color: #ef4444;
}
.wo-close-btn:hover { background: #fee2e2; }
.wo-body {
  flex: 1; overflow-y: auto; padding: 18px 22px;
  scrollbar-width: thin; scrollbar-color: #cbd5e1 transparent;
}
.wo-body::-webkit-scrollbar { width: 4px; }
.wo-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
.wo-card {
  background: #fff; border: 1px solid #e2e8f0;
  border-radius: 12px; margin-bottom: 14px; overflow: visible;
}
.wo-card-head {
  display: flex; align-items: center; gap: 9px;
  padding: 10px 16px; background: #f8fafc;
  border-bottom: 1px solid #e8edf3;
  border-radius: 12px 12px 0 0;
}
.wo-card-icon {
  width: 24px; height: 24px; border-radius: 6px;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; flex-shrink: 0;
}
.wo-card-title { font-size: 12px; font-weight: 700; color: #0f172a; letter-spacing: .1px; }
.wo-card-body { padding: 14px 16px; }
.wo-label {
  font-size: 11px; font-weight: 600; color: #475569;
  margin-bottom: 4px; display: block;
}
.wo-input {
  width: 100%; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 11px; font-size: 12.5px; color: #1e293b;
  background: #fff; outline: none; height: 35px;
  transition: border-color .15s, box-shadow .15s;
}
.wo-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.1);
}
.wo-input:disabled {
  background: #f8fafc; color: #94a3b8; cursor: not-allowed;
}
.wo-err-msg {
  font-size: 10.5px; color: #f43f5e; margin-top: 3px;
  display: flex; align-items: center; gap: 3px;
}
.wo-item-card {
  background: #fff; border: 1.5px solid #e8edf3;
  border-radius: 10px; padding: 14px 14px 10px;
  margin-bottom: 10px; position: relative;
  transition: border-color .15s, box-shadow .15s;
}
.wo-item-card:hover { border-color: #bfdbfe; box-shadow: 0 2px 10px rgba(59,130,246,.07); }
.wo-item-num {
  position: absolute; top: -9px; left: 14px;
  width: 19px; height: 19px; background: #e84040; color: #fff;
  border-radius: 50%; font-size: 9px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
}
.wo-remove-btn {
  width: 30px; height: 30px; border-radius: 7px;
  background: #fff0f3; border: 1.5px solid #fecdd3;
  color: #f43f5e; font-size: 13px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.wo-remove-btn:hover { background: #f43f5e; border-color: #f43f5e; color: #fff; }
.wo-add-item-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 14px; background: #eff6ff;
  border: 1.5px dashed #93c5fd; border-radius: 8px;
  color: #2563eb; font-size: 11.5px; font-weight: 600;
  cursor: pointer; transition: all .15s;
}
.wo-add-item-btn:hover { background: #dbeafe; border-color: #3b82f6; }
.wo-footer {
  background: #fff; border-top: 1px solid #e2e8f0;
  padding: 11px 22px; display: flex; align-items: center; gap: 8px; flex-shrink: 0; flex-wrap: wrap;
}
.wo-btn {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 7px 15px; border-radius: 8px; font-size: 12px;
  font-weight: 600; cursor: pointer; border: 1.5px solid transparent;
  transition: all .15s; text-decoration: none; white-space: nowrap;
}
.wo-btn-primary {
  background: linear-gradient(135deg,#e84040,#ef4444);
  color: #fff; border-color: #e84040;
  box-shadow: 0 2px 8px rgba(232,64,64,.25);
}
.wo-btn-primary:hover { background: linear-gradient(135deg,#dc2626,#e84040); }
.wo-btn-ghost { background: #f8fafc; color: #475569; border-color: #e2e8f0; }
.wo-btn-ghost:hover { background: #f1f5f9; }
:deep(.vs__dropdown-toggle) {
  border: 1.5px solid #e2e8f0 !important; border-radius: 8px !important;
  min-height: 35px !important; padding: 0 8px !important;
}
:deep(.vs__dropdown-toggle:focus-within) {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59,130,246,.1) !important;
}
:deep(.vs__search) { font-size: 12.5px !important; color: #1e293b !important; }
:deep(.vs__selected) {
  font-size: 12px !important; color: #1e293b !important;
  background: #eff6ff !important; border: 1px solid #bfdbfe !important;
  border-radius: 5px !important;
}
</style>

<template>

<!-- ═══════════════════════════════════════════════
     ADD / EDIT / VIEW WORK ORDER — FULLSCREEN
═══════════════════════════════════════════════ -->
<div class="modal fade" id="work_order_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen" style="margin:0;">
    <div class="modal-content border-0 h-100" style="border-radius:0;">

      <div class="wo-main">

        <!-- Topbar -->
        <div class="wo-topbar">
          <div>
            <div class="wo-page-title">
              {{ viewMode ? 'View Work Order' : (id ? 'Edit Work Order' : 'Create Work Order') }}
              <span v-if="viewMode && code" style="font-size:12px;color:#94a3b8;font-weight:400;margin-left:8px;">{{ code }}</span>
            </div>
            <div class="wo-page-sub">
              {{ viewMode ? 'Work order details' : (id ? 'Update work order details below' : 'Fill in the details to create a new work order') }}
            </div>
          </div>
          <button type="button" class="wo-close-btn" data-bs-dismiss="modal">
            <i class="ti ti-x"></i>
          </button>
        </div>

        <!-- Form -->
        <form @submit.prevent="saveWorkOrder" class="d-flex flex-column" style="flex:1;overflow:hidden;">
          <div class="wo-body">

            <!-- ── 1. Work Order Information ── -->
            <div class="wo-card">
              <div class="wo-card-head">
                <div class="wo-card-icon" style="background:#fff0f0;"><i class="ti ti-clipboard-list" style="color:#e84040;"></i></div>
                <span class="wo-card-title">Work Order Information</span>
              </div>
              <div class="wo-card-body">
                <div class="row g-3">

                  <div class="col-md-8">
                    <label class="wo-label">Work Order Name <span v-if="!viewMode" style="color:#f43f5e;">*</span></label>
                    <input type="text" class="wo-input" v-model="name" :disabled="viewMode" placeholder="Enter work order name" />
                    <div v-if="errors.name" class="wo-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.name[0] }}</div>
                  </div>

                  <div class="col-md-4">
                    <label class="wo-label">Type <span v-if="!viewMode" style="color:#f43f5e;">*</span></label>
                    <select class="wo-input" v-model="type" :disabled="viewMode">
                      <option value="manufacturing">Manufacturing</option>
                      <option value="trading">Trading</option>
                    </select>
                    <div v-if="errors.type" class="wo-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.type[0] }}</div>
                  </div>

                  <div class="col-md-4" v-if="party_type === 'App\\Models\\Lead'">
                    <label class="wo-label">Quotation <span style="color:#94a3b8;font-size:10px;font-weight:400;margin-left:4px;">(Optional)</span></label>
                    <vue-select
                      :options="quotations_dropdown"
                      v-model="quotation_id"
                      :reduce="q => q.id"
                      :get-option-label="q => q.revision_number > 0
                        ? `${q.quotation_number} (Revised ${q.revision_number})`
                        : `${q.quotation_number} (Original)`"
                      placeholder="Select Quotation"
                      :clearable="true"
                      :disabled="viewMode"
                      @update:modelValue="onQuotationSelect"
                    />
                    <div v-if="errors.quotation_id" class="wo-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.quotation_id[0] }}</div>
                  </div>

                  <div class="col-md-4">
                    <label class="wo-label">Pincode <span v-if="!viewMode" style="color:#f43f5e;">*</span></label>
                    <input type="text" class="wo-input" v-model="pincode" maxlength="6" :disabled="viewMode"
                      @keyup="checkPincode" placeholder="Enter pincode" />
                    <div v-if="errors.pincode" class="wo-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.pincode[0] }}</div>
                  </div>



                  <div class="col-md-8">
                    <label class="wo-label">Street Address <span v-if="!viewMode" style="color:#f43f5e;">*</span></label>
                    <input type="text" class="wo-input" v-model="address" :disabled="viewMode" placeholder="Enter full address" />
                    <div v-if="errors.address" class="wo-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.address[0] }}</div>
                  </div>

                  <div class="col-md-4">
                    <label class="wo-label">City  </label>
                    <input type="text" class="wo-input" v-model="city" readonly :disabled="viewMode" placeholder="Auto-filled from pincode" />
                    <div v-if="errors.city" class="wo-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.city[0] }}</div>
                  </div>

                  <div class="col-md-4">
                    <label class="wo-label">State</label>
                    <input type="text" class="wo-input" v-model="state" readonly :disabled="viewMode" placeholder="Auto-filled from pincode" />
                    <div v-if="errors.state" class="wo-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.state[0] }}</div>
                  </div>

                  <div class="col-md-4">
                    <label class="wo-label">Country</label>
                    <input type="text" class="wo-input" v-model="country" readonly :disabled="viewMode" placeholder="Auto-filled from pincode" />
                    <div v-if="errors.country" class="wo-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.country[0] }}</div>
                  </div>

                </div>
              </div>
            </div>

            <!-- ── Summary Bar ── -->
            <div class="wo-card" v-if="name || city || address">
              <div class="wo-card-head">
                <div class="wo-card-icon" style="background:#f0fdf4;"><i class="ti ti-clipboard-check" style="color:#22c55e;"></i></div>
                <span class="wo-card-title">Work Order Summary</span>
              </div>
              <div class="wo-card-body" style="padding:12px 16px;">
                <div style="display:flex;flex-wrap:wrap;gap:10px;">
                  <!-- Name -->
                  <div style="flex:1.5;min-width:160px;background:#f8fafc;border:1px solid #eef0f6;border-radius:8px;padding:10px 12px;display:flex;align-items:center;gap:8px;">
                    <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#fff0f0;border-radius:6px;">
                      <i class="ti ti-clipboard-list" style="font-size:14px;color:#e84040;"></i>
                    </span>
                    <div style="overflow:hidden;">
                      <span style="font-size:10px;color:#9e9e9e;text-transform:uppercase;letter-spacing:0.4px;display:block;">Name</span>
                      <span style="font-size:13px;font-weight:600;color:#1a1d23;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;">{{ name || '-' }}</span>
                    </div>
                  </div>
                  <!-- City -->
                  <div style="flex:1;min-width:120px;background:#f8fafc;border:1px solid #eef0f6;border-radius:8px;padding:10px 12px;display:flex;align-items:center;gap:8px;">
                    <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#f0faf0;border-radius:6px;">
                      <i class="ti ti-map-pin" style="font-size:14px;color:#22c55e;"></i>
                    </span>
                    <div>
                      <span style="font-size:10px;color:#9e9e9e;text-transform:uppercase;letter-spacing:0.4px;display:block;">City</span>
                      <span style="font-size:13px;font-weight:600;color:#1a1d23;">{{ city || '-' }}</span>
                    </div>
                  </div>
                  <!-- Address -->
                  <div style="flex:2;min-width:180px;background:#f8fafc;border:1px solid #eef0f6;border-radius:8px;padding:10px 12px;display:flex;align-items:center;gap:8px;">
                    <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#fef9ee;border-radius:6px;">
                      <i class="ti ti-home" style="font-size:14px;color:#f59e0b;"></i>
                    </span>
                    <div style="overflow:hidden;">
                      <span style="font-size:10px;color:#9e9e9e;text-transform:uppercase;letter-spacing:0.4px;display:block;">Address</span>
                      <span style="font-size:13px;font-weight:600;color:#1a1d23;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;">{{ address || '-' }}</span>
                    </div>
                  </div>
                  <!-- Pincode -->
                  <div v-if="pincode" style="flex:1;min-width:100px;background:#f8fafc;border:1px solid #eef0f6;border-radius:8px;padding:10px 12px;display:flex;align-items:center;gap:8px;">
                    <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#eff6ff;border-radius:6px;">
                      <i class="ti ti-hash" style="font-size:14px;color:#3b82f6;"></i>
                    </span>
                    <div>
                      <span style="font-size:10px;color:#9e9e9e;text-transform:uppercase;letter-spacing:0.4px;display:block;">Pincode</span>
                      <span style="font-size:13px;font-weight:600;color:#1a1d23;">{{ pincode }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ── 2. Items ── -->
            <div class="wo-card">
              <div class="wo-card-head">
                <div class="wo-card-icon" style="background:#fffbeb;"><i class="ti ti-list-details" style="color:#f59e0b;"></i></div>
                <span class="wo-card-title">Work Order Items</span>
                <button v-if="!viewMode" type="button" class="wo-add-item-btn ms-auto" @click="addItem">
                  <i class="ti ti-plus"></i> Add Item
                </button>
              </div>
              <div class="wo-card-body">

                <div v-if="errors.items" class="wo-err-msg mb-3">
                  <i class="ti ti-alert-circle"></i>{{ errors.items[0] }}
                </div>

                <div v-for="(item, index) in items" :key="index" class="wo-item-card">
                  <div class="wo-item-num">{{ index + 1 }}</div>
                  <div class="row g-2 align-items-end">

                    <!-- CATEGORY -->
                    <div class="col-md-3">
                      <label class="wo-label">Category</label>
                      <vue-select :options="item_groups" label="name" :reduce="g => g.id"
                        v-model="item.item_group_id" placeholder="Select Category"
                        :disabled="viewMode"
                        @update:modelValue="val => onCategorySelect(index, val)" />
                    </div>

                    <!-- ITEM -->
                    <div class="col-md-3">
                      <label class="wo-label">Item <span v-if="!viewMode" style="color:#f43f5e;">*</span></label>
                      <vue-select :options="item.unique_items" label="name" v-model="item.item_name"
                        :reduce="i => i.name" placeholder="Select Item"
                        :disabled="viewMode || !item.item_group_id"
                        @update:modelValue="val => onUniqueItemSelect(index, val)" />
                      <div v-if="errors[`items.${index}.item_id`]" class="wo-err-msg">
                        <i class="ti ti-alert-circle"></i>{{ errors[`items.${index}.item_id`][0] }}
                      </div>
                    </div>

                    <!-- BRAND -->
                    <div class="col-md-2">
                      <label class="wo-label">Brand</label>
                      <vue-select :options="item.items_list"
                        :get-option-label="opt => opt.brand?.name || 'N/A'"
                        v-model="item.item" placeholder="Select Brand"
                        :disabled="viewMode || !item.item_name"
                        @update:modelValue="val => onBrandSelect(index, val)">
                        <template v-slot:option="opt">
                          <div style="display:flex;justify-content:space-between;width:100%;">
                            <span>{{ opt.brand?.name || 'N/A' }}</span>
                            <span style="color:#64748b;font-size:11px;">₹{{ opt.price }}</span>
                          </div>
                        </template>
                      </vue-select>
                    </div>

                    <!-- UNIT (only when dimensional) -->
                    <div class="col-md-1" v-if="item.calculation_type === 'dimensional'">
                      <label class="wo-label">Unit</label>
                      <vue-select :options="item.availableUnits" label="label" :reduce="u => u"
                        v-model="item.selectedUnit" placeholder="Unit"
                        :disabled="viewMode || item.unit === 'Rmt'"
                        @update:modelValue="val => onItemUnitSelected(index, val)" />
                    </div>

                    <div class="col-md-2" v-if="item.calculation_type !== 'dimensional'">
                      <label class="wo-label">Allocated Qty</label>
                      <input type="number" class="wo-input" v-model="item.allocated_quantity" min="1" :disabled="viewMode" />
                    </div>

                    <div class="col-md-1" v-if="viewMode">
                      <label class="wo-label">Available</label>
                      <input type="number" class="wo-input" v-model="item.available_quantity" min="0" disabled />
                    </div>

                    <div class="col-md-1">
                      <label class="wo-label">Unit Price</label>
                      <input type="number" class="wo-input" v-model="item.unit_price" min="0" step="0.01" :disabled="viewMode" @input="updateAmount(index)" />
                    </div>

                    <div class="col-md-1 d-flex align-items-end" v-if="!viewMode">
                      <button v-if="items.length > 1" type="button" class="wo-remove-btn" @click="removeItem(index)">
                        <i class="ti ti-trash"></i>
                      </button>
                    </div>

                    <!-- DIMENSIONS BLOCK -->
                    <template v-if="item.calculation_type === 'dimensional'">
                      <div class="col-12">
                        <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:10px 12px;">
                          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;">
                            <span style="font-size:11px;font-weight:600;color:#475569;">Dimensions</span>
                            <button v-if="!viewMode" type="button" class="wo-add-item-btn" style="padding:4px 10px;font-size:10px;" @click="addDimensionRow(index)">
                              <i class="ti ti-plus"></i> Add Row
                            </button>
                          </div>
                          <div v-for="(dim, dIndex) in item.dimensions" :key="dIndex"
                            style="display:flex;align-items:end;gap:8px;margin-bottom:6px;">
                            <div style="flex:1;">
                              <label class="wo-label" v-if="dIndex === 0">Width (mm)</label>
                              <input type="number" class="wo-input" v-model.number="dim.width" @input="updateAmount(index)" placeholder="0" min="0" :disabled="viewMode" />
                            </div>
                            <div style="flex:1;">
                              <label class="wo-label" v-if="dIndex === 0">Height (mm)</label>
                              <input type="number" class="wo-input" v-model.number="dim.height" @input="updateAmount(index)" placeholder="0" min="0" :disabled="viewMode" />
                            </div>
                            <div style="flex:1;">
                              <label class="wo-label" v-if="dIndex === 0">Qty</label>
                              <input type="number" class="wo-input" v-model.number="dim.qty" @input="updateAmount(index)" placeholder="1" min="1" :disabled="viewMode" />
                            </div>
                            <div style="flex:0 0 70px;">
                              <label class="wo-label" v-if="dIndex === 0">Size</label>
                              <input type="text" class="wo-input" :value="(dim._size || 0).toFixed(2)" readonly
                                style="background:#f0fdf4;font-weight:600;color:#16a34a;font-size:11px;text-align:center;" />
                            </div>
                            <div style="flex:0 0 90px;">
                              <label class="wo-label" v-if="dIndex === 0">Amount</label>
                              <input type="text" class="wo-input" :value="(dim._amount || 0).toFixed(2)" readonly
                                style="background:#eff6ff;font-weight:600;color:#2563eb;font-size:11px;text-align:center;" />
                            </div>
                            <div style="flex-shrink:0;" v-if="!viewMode">
                              <button type="button" class="wo-remove-btn" style="width:28px;height:28px;" @click="removeDimensionRow(index, dIndex)"
                                :disabled="item.dimensions.length === 1"
                                :style="item.dimensions.length === 1 ? 'opacity:0.3;cursor:not-allowed;' : ''">
                                <i class="ti ti-trash" style="font-size:12px;"></i>
                              </button>
                            </div>
                          </div>
                          <div style="display:flex;justify-content:flex-end;margin-top:6px;gap:16px;">
                            <span style="font-size:11px;color:#64748b;">Total Size: <b style="color:#1e293b;">{{ (item.size || 0).toFixed(2) }}</b></span>
                            <span style="font-size:11px;color:#64748b;">Total Qty: <b style="color:#1e293b;">{{ item.allocated_quantity }}</b></span>
                          </div>
                        </div>
                      </div>
                    </template>

                  </div>
                </div>

                <div v-if="!items.length" style="text-align:center;padding:28px;color:#94a3b8;">
                  <i class="ti ti-inbox" style="font-size:28px;display:block;margin-bottom:6px;opacity:.4;"></i>
                  No items added yet.
                </div>

                <!-- Totals in viewMode -->
                <div v-if="viewMode && (subtotal || tax_amount || total)" style="border-top:1px dashed #e2e8f0;margin-top:14px;padding-top:14px;display:flex;justify-content:flex-end;">
                  <div style="min-width:220px;">
                    <div style="display:flex;justify-content:space-between;padding:5px 0;font-size:12px;color:#64748b;">
                      <span>Subtotal</span>
                      <span style="font-weight:600;color:#1e293b;">{{ formatCurrency(subtotal) }}</span>
                    </div>
                    <div style="display:flex;justify-content:space-between;padding:5px 0;font-size:12px;color:#64748b;">
                      <span>Tax</span>
                      <span style="font-weight:600;color:#1e293b;">{{ formatCurrency(tax_amount) }}</span>
                    </div>
                    <div style="display:flex;justify-content:space-between;padding:8px 0;font-size:13px;font-weight:700;color:#1a1d23;border-top:2px solid #e2e8f0;margin-top:4px;">
                      <span>Total</span>
                      <span style="color:#e84040;">{{ formatCurrency(total) }}</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!-- ── Documents (View Mode) ── -->
            <div class="wo-card" v-if="viewMode && documents.length">
              <div class="wo-card-head">
                <div class="wo-card-icon" style="background:#faf5ff;"><i class="ti ti-file" style="color:#8b5cf6;"></i></div>
                <span class="wo-card-title">Documents</span>
              </div>
              <div class="wo-card-body">
                <div style="display:flex;flex-wrap:wrap;gap:12px;">
                  <div v-for="doc in documents" :key="doc.id">
                    <!-- Image -->
                    <div v-if="doc.type && doc.type.startsWith('image/')"
                      style="border:1.5px solid #e2e8f0;border-radius:10px;overflow:hidden;width:150px;">
                      <a :href="doc.document_url" target="_blank">
                        <img :src="doc.document_url"
                          style="width:150px;height:110px;object-fit:cover;display:block;" />
                      </a>
                      <div style="padding:6px 8px;font-size:11px;color:#64748b;background:#f8fafc;text-align:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                        {{ doc.name || 'Document' }}
                      </div>
                    </div>
                    <!-- PDF / Other -->
                    <a v-else :href="doc.document_url" target="_blank"
                      style="display:flex;align-items:center;gap:8px;padding:10px 14px;border:1.5px solid #e2e8f0;border-radius:10px;background:#f8fafc;text-decoration:none;min-width:150px;">
                      <i class="ti ti-file-type-pdf" style="font-size:22px;color:#e84040;flex-shrink:0;"></i>
                      <span style="font-size:12px;font-weight:500;color:#1e293b;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                        {{ doc.name || 'Document' }}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- ── 3. Document Upload ── -->
            <div class="wo-card" v-if="!viewMode && !id">
              <div class="wo-card-head">
                <div class="wo-card-icon" style="background:#faf5ff;"><i class="ti ti-file-upload" style="color:#8b5cf6;"></i></div>
                <span class="wo-card-title">Document <span style="color:#94a3b8;font-size:10px;font-weight:400;margin-left:4px;">(Optional)</span></span>
              </div>
              <div class="wo-card-body">

                <div v-if="!documentName"
                  style="border:2px dashed #e2e8f0;border-radius:10px;padding:28px;text-align:center;cursor:pointer;background:#fafafa;transition:all .15s;"
                  @click="$refs.woDocInput.click()"
                  @dragover.prevent
                  @drop.prevent="handleDocChange({ target: { files: $event.dataTransfer.files } })"
                  @mouseenter="$event.target.style.borderColor='#8b5cf6'"
                  @mouseleave="$event.target.style.borderColor='#e2e8f0'">
                  <i class="ti ti-cloud-upload" style="font-size:32px;color:#94a3b8;display:block;margin-bottom:8px;"></i>
                  <div style="font-size:13px;font-weight:600;color:#475569;">Click to upload or drag & drop</div>
                  <div style="font-size:11px;color:#94a3b8;margin-top:4px;">PDF, JPG, PNG (Max 5MB)</div>
                  <input type="file" ref="woDocInput" style="display:none;" accept=".pdf,.jpg,.jpeg,.png" @change="handleDocChange" />
                </div>

                <div v-else
                  style="display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border:1.5px solid #e2e8f0;border-radius:10px;background:#f8fafc;">
                  <div style="display:flex;align-items:center;gap:10px;">
                    <div style="width:36px;height:36px;background:#faf5ff;border-radius:8px;display:flex;align-items:center;justify-content:center;">
                      <i class="ti ti-file-filled" style="font-size:17px;color:#8b5cf6;"></i>
                    </div>
                    <div>
                      <div style="font-size:13px;font-weight:600;color:#1e293b;">{{ documentName }}</div>
                      <div style="font-size:11px;color:#94a3b8;">Ready to upload</div>
                    </div>
                  </div>
                  <button type="button" class="wo-remove-btn" @click="removeDoc">
                    <i class="ti ti-trash"></i>
                  </button>
                </div>

              </div>
            </div>

          </div><!--  -->

          <!-- Footer -->
          <div class="wo-footer">
            <button type="button" class="wo-btn wo-btn-ghost me-auto" @click="addItem" v-if="!viewMode">
              <i class="ti ti-plus"></i> Add Item
            </button>
            <button type="button" class="wo-btn wo-btn-ghost" data-bs-dismiss="modal">
              {{ viewMode ? 'Close' : 'Cancel' }}
            </button>
            <button v-if="!viewMode" type="submit" class="wo-btn wo-btn-primary">
              <i class="ti ti-device-floppy"></i> {{ id ? 'Update' : 'Save' }} Work Order
            </button>
          </div>

        </form>
      </div><!--  -->

    </div>
  </div>
</div>

</template>